module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.a288961.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/font/notokr-regular.woff2
// module id = L7O8
// module chunks = 0